import { createStyles, useMantineTheme } from '@mantine/core';

import IconCheckSmall from './IconCheckSmall';

// Design-specific sizes not available in theme spacing
const CONTAINER_SIZE = 56;
const CHECKMARK_SIZE = 28;
const BORDER_RADIUS = 40;

const useStyles = createStyles((theme, params: { backgroundColor?: string }) => ({
  container: {
    width: CONTAINER_SIZE,
    height: CONTAINER_SIZE,
    backgroundColor: params.backgroundColor ?? theme.colors.gray2[0],
    borderRadius: BORDER_RADIUS,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

type SuccessCheckmarkProps = {
  checkmarkColor?: string;
  backgroundColor?: string;
};

function SuccessCheckmark({ checkmarkColor, backgroundColor }: SuccessCheckmarkProps = {}) {
  const theme = useMantineTheme();
  const { classes } = useStyles({ backgroundColor });

  // Use theme color as default, but allow override via prop for flexibility
  const iconColor = checkmarkColor ?? theme.colors.blue[7];

  return (
    <div className={classes.container}>
      <IconCheckSmall size={CHECKMARK_SIZE} color={iconColor} />
    </div>
  );
}

SuccessCheckmark.displayName = 'SuccessCheckmark';

export { SuccessCheckmark };
